import {useState} from "react";
import {UsersListLoading} from "../../Reviews/Review/users-list/components/loading/UsersListLoading";
import {KTCardBody} from "../../../../_metronic/helpers";
import {TopUpModal} from "../modals/TopUpModal";
import {UsagesModal} from "../modals/UsagesModal";
import {DisableModal} from "../modals/DisableModal";
import {Pagination} from "../../../../components/Pagination";
import { Link } from "react-router-dom";
import { useAuth } from "../../auth";
import { formatNumber } from '../../../../_metronic/helpers/utils';

const headers = [
    {title: 'Name', width: '140px', access_key: 'partner_users_list'},
    {title: 'Status', width: '120px', access_key: 'partner_users_list'},
    {title: 'API Usages', width: '200px', access_key: 'partner_users_list'},
    {title: 'Webhook', width: '260px', access_key: 'partner_users_list'},
    {title: '', width: '180px', access_key: 'partner_users_topup'},
    {title: '', width: '120px', access_key: 'partner_users_details'},
    {title: '', width: '130px', access_key: 'partner_users_disable'},
]


export const UserApiTable = ({data, isLoading, fetchApiUsage, total, page, setPage, pageSize, setPageSize}) => {
    const { currentUser, haveAccess } = useAuth();
    const [topUpModalData, setTopUpModalData] = useState(null);
    const [usagesModalData, setUsagesModalData] = useState(null);
    const [disableModalData, setDisableModalData] = useState(null);

    return (
        <KTCardBody className='py-4'>
            <h6 style={{color:'#7e8299', textAlign:'right'}}>Total: {total} </h6>
            <div className='table-responsive'>
                <table
                    id='kt_table_users'
                    className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
                >
                    <thead>
                    <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
                        {headers.map((column, index) => (
                            haveAccess(currentUser, column.access_key) && (
                                <th
                                    key={index}
                                    className={column.className}
                                    style={{minWidth: column.width}}
                                >
                                    {column.title}
                                </th>
                            )
                        ))}
                    </tr>
                    </thead>
                    <tbody className='text-gray-600 fw-bold'>
                    {data && data.length > 0 && (
                        data.map(row => (
                            <tr key={row.partner_id}>
                                <td style={{minWidth: headers[0].width,  width: '100%'}}>
                                <Link to={`/users/${row.uid}`}>{row.name}</Link>
                                </td>
                                <td style={{ minWidth: headers[1].width, color: row.is_active ? '#2ecc71' : '#ed2626' }}>
                                    {row.is_active  ? "Active" : "Disabled"}
                                </td>
                                <td style={{minWidth: headers[2].width}}>
                                    <div style={{
                                        backgroundColor: 'rgb(192, 192, 192)',
                                        borderRadius: 15,
                                        position: 'relative',
                                        height: 20,
                                        overflow: 'hidden',
                                    }}>
                                        <div
                                            style={{
                                                width: `${row.used / row.usage_limit * 100}%`,
                                                height: '100%',
                                                backgroundColor: 'rgb(116, 194, 92)',
                                                borderRadius: 15
                                            }}
                                        />
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: '100%',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                color: '#fff'
                                            }}
                                        >
                                            {formatNumber(row?.used)} / {formatNumber(row?.usage_limit)}
                                        </div>
                                    </div>
                                </td>
                                <td style={{minWidth: headers[3].width}}>{row.webhook || '-'}</td>
                                {haveAccess(currentUser, 'partner_users_topup') && 
                                <td style={{minWidth: headers[4].width}}>
                                    <button
                                        className="btn btn-sm btn-success"
                                        onClick={() => setTopUpModalData(row)}
                                    >
                                        Increase/Decrease API Limit
                                    </button>
                                </td>
                                }
                                {haveAccess(currentUser, 'partner_users_details') && <td style={{minWidth: headers[5].width}}>
                                    <button
                                        className="btn btn-sm btn-success"
                                        onClick={() => setUsagesModalData(row)}
                                    >
                                        Show Logs
                                    </button>
                                </td>
                                }
                                {haveAccess(currentUser, 'partner_users_disable') &&
                                <td style={{minWidth: headers[6].width}}>
                                    <button
                                        className="btn btn-sm btn-danger"
                                        onClick={() => setDisableModalData(row)}
                                    >
                                        Disable Access
                                    </button>
                                </td>
                                }
                            </tr>
                        ))
                    )}
                    </tbody>
                </table>
                {data && !data.length > 0 &&
                    <div
                        className='d-flex text-center text-gray-600 fw-bolder fs-6 w-100 align-content-center justify-content-center mt-10'>
                        No matching records found
                    </div>
                }
                <Pagination
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    total={total}
                />
            </div>
            {isLoading && <UsersListLoading/>}

            {topUpModalData && (
                <TopUpModal
                    data={topUpModalData}
                    onClose={() => setTopUpModalData(null)}
                    fetchApiUsage={fetchApiUsage}
                    formatNumber={formatNumber}
                />
            )}
            {usagesModalData && (
                <UsagesModal
                    data={usagesModalData}
                    onClose={() => setUsagesModalData(null)}
                />
            )}
            {disableModalData && (
                <DisableModal
                    data={disableModalData}
                    onClose={() => setDisableModalData(null)}
                    fetchApiUsage={fetchApiUsage}
                />
            )}
        </KTCardBody>
    );
};
